<template>
  <custom-modal
    class="custom-modal__extended"
    id="generate-report-modal"
    ref="modalRef"
    v-b-modal.modal-center
    :title="$t('GenerateReport.Title')"
    :hide-backdrop="hideModalBackdrop"
    @accept="() => {}"
    @hide="onHideHandler"
  >
    <div id="report-container" class="font-14 border-bottom pb-4">
      <div ref="highlight" class="highlight"></div>
      <validation-observer ref="formRef" v-slot="{}" tag="form">
        <div class="row mt-4">
          <div class="col-md-12">
            <validation-provider rules="required" v-slot="{ errors }">
              <div class="color-primary-4 font-14 font-weight-bold mb-1">
                {{ $t('GenerateReport.University.Text') }}:
              </div>
              <custom-drop-down
                label=""
                placeholder="Seleccione"
                :options="options.universities"
                fieldkey="id"
                fieldname="name"
                v-model="model.university"
                @input="() => {}"
                :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`"
              />
            </validation-provider>
          </div>
          <div class="col-md-12 mt-4">
            <validation-provider rules="required" v-slot="{ errors }">
              <div class="color-primary-4 font-14 font-weight-bold mb-1">
                {{ $t('GenerateReport.Specialty.Text') }}:
              </div>
              <custom-drop-down
                label=""
                placeholder="Seleccione"
                :options="options.specialities"
                fieldkey="id"
                fieldname="name"
                v-model="model.specialty"
                @input="() => {}"
                :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`"
              />
            </validation-provider>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-6">
            <validation-provider rules="required" v-slot="{ errors }">
              <div class="color-primary-4 font-14 font-weight-bold mb-1">
                {{ $t('GenerateReport.Grade.Text') }}:
              </div>
              <custom-drop-down
                label=""
                placeholder="Seleccione"
                :options="options.grades"
                fieldkey="id"
                fieldname="name"
                v-model="model.grade"
                @input="() => {}"
                :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`"
              />
            </validation-provider>
          </div>
          <div class="col-md-6">
            <validation-provider rules="required" v-slot="{ errors }">
              <div class="color-primary-4 font-14 font-weight-bold mb-1">
                {{ $t('GenerateReport.Gender.Text') }}:
              </div>
              <custom-drop-down
                label=""
                placeholder="Seleccione"
                :options="options.genders"
                fieldkey="id"
                fieldname="name"
                v-model="model.gender"
                @input="() => {}"
                :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`"
              />
            </validation-provider>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-6">
            <validation-provider rules="required" v-slot="{ errors }">
              <div class="color-primary-4 font-14 font-weight-bold mb-1">
                {{ $t('From') }}:
              </div>
              <custom-date-picker
                v-model="model.dateFrom"
                class="input__exteded"
                placeholder="DD/MM/YYYY"
                class-container="w-100"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
          <div class="col-md-6">
            <validation-provider rules="required" v-slot="{ errors }">
              <div class="color-primary-4 font-14 font-weight-bold mb-1">
                {{ $t('To') }}:
              </div>
              <custom-date-picker
                v-model="model.dateTo"
                class="input__exteded"
                placeholder="DD/MM/YYYY"
                class-container="w-100"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
        </div>
      </validation-observer>
    </div>
    <template #footer>
      <div class="d-flex align-items-center justify-content-center pb-3">
        <action-button
          class="outline-warning px-3 py-2"
          i="fa fa-xmark-circle"
          :text="$t('GenerateReport.btnCancel.Text')"
          @click="hideModal"
        />

        <action-button
          class="btn-success px-4 py-2 ml-4"
          :text="$t('GenerateReport.btnGenerate.Text')"
          i="fa fa-circle-check"
          @click="onContinueHandler"
        />
      </div>
    </template>
  </custom-modal>
</template>

<script>
//libs
import { i18n } from '@/i18n';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import CustomDatePicker from 'custom-date-picker';

//common components
import { CustomModal } from '@/components/common';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

//services

export default {
  name: 'GenerateReportModal',
  mixins: [alertMixin],
  components: {
    CustomModal,
    ActionButton,
    CustomDropDown,
    CustomDatePicker,
  },
  data: () => ({
    hideModalBackdrop: false,
    model: {
      university: null,
      specialty: null,
      Grade: null,
      gender: null,
      dateFrom: null,
      dateTo: null,
    },
    options: {
      universities: [],
    },
  }),
  mounted() {},
  computed: {},
  methods: {
    showModal() {
      this.$refs.modalRef.showModal();
    },
    hideModal() {
      this.$refs.modalRef.hideModal();
    },

    async onContinueHandler() {
      const isValid = await this.$refs.formRef.validate();
      if (!isValid) {
        this.ShowToast(
          i18n.t('Alert'),
          `${i18n.t('PleaseCompleteRequestedInformation')}.`,
          'error'
        );
        return;
      }
    },
    onHideHandler() {
      this.model = {
        university: null,
        specialty: null,
        Grade: null,
        gender: null,
        dateFrom: null,
        dateTo: null,
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';
@import '@/scss/bootstrap/_colors.scss';

.custom-modal__extended {
  ::v-deep .modal-dialog {
    max-width: 700px !important;
  }
}

::v-deep .btn-highlight {
  border-color: map-get($colors, 'dark-blue-1') !important;
  color: map-get($colors, 'dark-blue-1') !important;
}

::v-deep .btn-blackout {
  border-color: map-get($colors, 'dark-blue-1') !important;
  background: map-get($colors, 'dark-blue-1') !important;
}
</style>
